<!--
   Created by qing on 2020/3/6 7:13 下午
   Des:
-->
<template>
  <div v-if="loadingEnd" style="height: 100%">
    <img
      style="width: 0; height: 0;"
      :src="formSet.customShowImg || $store.getters.configMap.singleLogoImage"
      alt="">
    <div v-if="errorInfo">
      <div class="error-page" v-if="errorInfo">
        <img :src="`${$BASE_PATH}/fetch/image?id=376459314291802113.png`" alt="">
        <p>
          {{errorInfo.info}}({{errorInfo.status}})
        </p>
      </div>
    </div>
    <div class="posting-container" v-wechat-title="formSet.formName">
      <div
        v-if="checkType === CHECK_TYPE_PWD && !complete"
        class="link-posting__password">
        <div class="link-posting__password-container">
          <div class="header">
            {{queryTitle}}
          </div>
          <div class="password-container">
            <van-field
              v-model="password"
              placeholder="请输入密码">
            </van-field>
            <van-button
              type="primary"
              block
              @click="verify">
              确定
            </van-button>
          </div>
        </div>
      </div>
      <div class="form-set-posting" v-if="(checkType === CHECK_TYPE_NONE || complete) && !submitComplete">

        <template v-if="formSet.isInit">

          <div class="form-content">
            <header v-if="formSet.customFormStyle.headerType === FORM_THEME_TYPE_IMAGE">
              <van-image
                width="100%"
                :src="headImage">
              </van-image>
            </header>
            <Fill v-if="formSet.isInit" :formSet="formSet" :hasHeader="true">
            </Fill>
          </div>

          <div class="footer">
            <van-button
              :style="{color: applyBtnInfo.color, backgroundColor: applyBtnInfo.backgroundColor || '#05A971'}"
              @click="formSubmit">
              {{applyBtnInfo.name}}
            </van-button>
            <div
              class="disclaimer">
              <div>
                <span v-if="!hiddenLogo">由{{$store.getters.webName}}提供技术支持</span>
              </div>
              <a
                v-if="jumpReportUrl && (!$store.getters.functionConfigMap.hasOwnProperty('sys_diy_posting_jubao_show') || $store.getters.functionConfigMap.sys_diy_posting_jubao_show.showFunction)"
                :href="jumpReportUrl"
                target="_blank">
                违规举报
              </a>
            </div>
          </div>

          <FormOrderPopup
            ref="formOrderPopup"
            @submitOrder="submitOrder"
          ></FormOrderPopup>

          <!--打印-->
          <print-template-dialog
            v-if="formSet.isInit"
            ref="printTemplateDialog"
            :company-id="formSet.companyId"
            :app-id="formSet.appId"
            :form-id="formSet.formId"
            :instance-id="instanceId"
            scopeType="OUT_TYPE"
            data-id="OUT_TYPE">
          </print-template-dialog>
        </template>
      </div>
      <div v-if="submitComplete" class="submit-complete-container">
        <div
          v-if="formSet.afterJumpType === AFTER_JUMP_TYPE__DEFAULT || (formSet.afterJumpType === AFTER_JUMP_TYPE__URL && jumpFail)"
          class="submit-default-container">

          <van-image
            flt="cover"
            :src="`${$BASE_PATH}/fetch/image?id=437649976726651084.png`">
          </van-image>
          <div class="tips">提交成功</div>
          <van-button
            v-if="formSet.applyAgain"
            type="primary"
            size="small"
            @click="continueFill">
            再次填写
          </van-button>
        </div>

        <div
          class="submit-custom-container"
          v-if="formSet.afterJumpType === AFTER_JUMP_TYPE__CUSTOM || formSet.afterJumpType === AFTER_JUMP_TYPE__HTML">
          <froalaView v-model="customInfo"></froalaView>

          <div class="submit-custom-btn-container">
            <van-button type="primary" @click="continueFill">确定</van-button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Fill from "../../RyForm/redact/Fill"
  import RyFormSet from "../../RyForm"
  import PrintTemplateDialog from "../../component/PrintTemplateDialog";
  import FormOrderPopup from "../../component/FormOrderPopup";
  import {
    AFTER_JUMP_TYPE__CUSTOM,
    AFTER_JUMP_TYPE__DEFAULT,
    AFTER_JUMP_TYPE__HTML, AFTER_JUMP_TYPE__THIRD_PAGE,
    AFTER_JUMP_TYPE__URL, FORM_ITEM__CURRENT_VIEW_USER,
    FORM_ITEM__DEPARTMENT,
    FORM_ITEM__MEMBER,
    FORM_ITEM__RELATE_RECORD,
    FORM_STATUS__FILL,
    FORM_SUBMIT_ERROR,
    FORM_THEME_TYPE_IMAGE,
    FORM_TYPE__FILL,
    MESSAGE_TYPE_APPEND,
    MESSAGE_TYPE_DATA,
    MESSAGE_TYPE_SIGNATURE
  } from "../../RyForm/types"
  import {
    ENV_TYPE_LARK_MINI_PROGRAM,
    ENV_TYPE_SMALLPROGRAM,
    LINK_POSTING_PASSWORD_ERROR,
    SUCCESS
  } from "../../store/types"
  import {base64Decode, clone, handleMessage, isUndefined} from "../../../assets/js/Untis";

  const CHECK_TYPE_NONE = 'NONE'
  const CHECK_TYPE_PWD = 'PWD'
  export default {
    metaInfo() {
      return {
        title: this.formSet.formName, // set a title
        meta: [   // set meta
          {
            name: 'description',
            content: this.formSet.customContent || this.formSet.formName
          }
        ]
      }
    },
    data() {
      return {
        CHECK_TYPE_NONE,
        CHECK_TYPE_PWD,
        FORM_THEME_TYPE_IMAGE,
        AFTER_JUMP_TYPE__DEFAULT,
        AFTER_JUMP_TYPE__CUSTOM,
        AFTER_JUMP_TYPE__URL,
        AFTER_JUMP_TYPE__HTML,
        loadingEnd: false,
        // 密码验证是否通过
        complete: false,
        formId: '',
        extField: '',
        formSet: new RyFormSet(),
        checkType: CHECK_TYPE_NONE,
        queryTitle: '',
        password: '',
        submitComplete: false,
        customInfo: '',
        aEle: null,
        jumpFail: false,
        tempList: [],
        instanceId: '',
        jumpReportUrl: '',

        applyBtnInfo: {
          color: '#ffffff',
          name: '提交',
          backgroundColor: '#4A66FA'
        },

        currentFlowDetail: null,
        orderErrorMsgList: [],

        hiddenLogo: 1,
        errorInfo: null,

        lastApplyData: null,
        isSubmit: false,
      }
    },
    async created() {
      // this.$route.query.key
      // '5e5b8a6f006bb83e55006bff'
      // await this.$store.dispatch('actionWechatNodeGet', this.$route.query.key)
      //   .then(res => {
      //     this.formId = res.formId
      //     this.extField = res.extField
      //   })
      //   .catch(err => {
      //     console.error(err)
      //   })
      const lastApplyData = localStorage.getItem('apply_data')
      if (lastApplyData) this.lastApplyData = JSON.parse(lastApplyData)

      const query = this.$route.query
      this.formId = decodeURIComponent(query.f)
      this.extField = query.ext ? decodeURIComponent(query.ext) : ''

      // this.formId = '5e2831fe000d1c0a3b0012f8'
      this.$store.dispatch('actionLinkPreCheck', this.formId)
        .then(({status, resultObject, info}) => {
          this.loadingEnd = true
          if (status === SUCCESS) {
            this.checkType = resultObject.checkType
            this.queryTitle = resultObject.queryTitle
            if (this.checkType === CHECK_TYPE_NONE) {
              this.structure()
            }
          } else {
            this.errorInfo = {
              info,
              status
            }
          }
        })
        .catch(console.error)
      this.jumpReportUrl = `${this.$store.getters.configMap.reportJumpUrl}&ext=form&reportUrl=${location.href}`
      this.aEle = document.createElement('a')
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true)
      // 判断是否是微信浏览器
      if (window.isWexin || window.isWxWork) {
        window.addEventListener('pagehide', e => this.beforeunloadHandler())
      } else {
        // 监听普通页面离开事件
        window.addEventListener('beforeunload', e => this.beforeunloadHandler())
      }
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler())
      window.removeEventListener('pagehide', e => this.beforeunloadHandler())
    },
    computed: {
      headImage() {
        const headImg = this.formSet.customFormStyle.headerImage
        return headImg ? headImg : `${this.$BASE_PATH}/fetch/image?id=437649976726651087.png`
      }
    },
    components: {
      Fill,
      PrintTemplateDialog,
      FormOrderPopup
    },
    methods: {

      // 验证密码
      verify() {
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('actionTypeVerify', {
          formId: this.formId,
          checkType: this.checkType,
          password: this.password
        })
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.complete = true
              this.structure()
            } else if (status === LINK_POSTING_PASSWORD_ERROR) {
              this.$toast.fail('密码错误。')
            }
          })
          .finally(() => {
            toast.clear()
          })
          .catch(err => {
            this.$toast.fail('验证失败。')
            console.error(err)
          })
      },

      // 请求表单
      structure() {
        this.pageLoading = true
        this.$store.dispatch('actionTypeStructure', this.formId)
          .then(({permissionInfo, detailInfo, structureInfo, companyName, pluginList, bothRelateList, displayList}) => {

            this.formSet.setStructure(structureInfo)
            this.formSet.setPermission(permissionInfo.permissionList)
            this.formSet.setConf(detailInfo)
            this.formSet.setPlugin(pluginList)
            this.formSet.setBothRelate(bothRelateList)
            this.formSet.setDisplayRule(displayList)
            this.formSet.status = FORM_STATUS__FILL
            this.formSet.isLink = true
            this.companyName = companyName

            this.$store.dispatch('setPageTitle', this.formSet.formName)
            this.$store.commit('UPDATE__COMPANY_ID', this.formSet.companyId)
            Object.keys(this.formSet.fields).forEach(key => {
              let field = this.formSet.fields[key]
              if (field.type === FORM_ITEM__MEMBER || field.type === FORM_ITEM__DEPARTMENT) {
                field.hidden = 1
              }
            })

            this.$store.dispatch('actionCompanyLogoConfig', {companyId: this.formSet.companyId})
              .then(res => {
                this.hiddenLogo = res.hiddenLogo
              }).catch(console.error)

            const values = {}
            if (Object.keys(this.formSet.fields).includes('SINGLELINEk3azvuj8LPuiknbM')) {
              values['SINGLELINEk3azvuj8LPuiknbM'] = this.reportUrl
            }
            if (Object.keys(this.formSet.fields).includes('SINGLELINE_kda13cb09PtTkiWG')) {
              values['SINGLELINE_kda13cb09PtTkiWG'] = this.reportUrl
            }
            this.formSet.setValues(values)

            // URL扩展带的数据
            const query = this.$route.query
            const extURLParamList = this.formSet.extURLParamList
            if (query) {
              const addValues = {}
              extURLParamList.forEach(item => {
                if (query.hasOwnProperty(item.key) && query[item.key]) {
                  const value = decodeURIComponent(query[item.key])
                  if (value) {
                    addValues[item.fieldId] = value
                  }
                }
              })
              this.formSet.setValues(addValues)
            }

            this.$store.dispatch('actionPrintTempList', {
              companyId: this.formSet.companyId,
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              dataId: 'OUT_TYPE',
              scopeType: 'OUT_TYPE'
            })
              .then(res => {
                this.tempList = [...res.uploadList, ...res.wordTemplateList]
              })

            // 暂时注掉 0404
            // if (this.lastApplyData) {
            //   this.formSet.setValues(this.lastApplyData)
            //   localStorage.removeItem('apply_data')
            // }

            return this.$store.dispatch('actionFormDefaultSubmitData', {
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              data: this.formSet.getValues()
            })
            // 权限
          })
          .then(res => {

            this.fetchFlowDetail()
            this.formSet.setValues(res)

            // 加载微信jssdk
            if (window.isWxWork ||
              window.isWexin ||
              !this.$store.getters.env ||
              this.$store.getters.env === ENV_TYPE_SMALLPROGRAM) {

              this.$store.dispatch('actionWechatTicket', location.href.split('#')[0])
                .then(res => {
                  console.log('$wx-config', this.$wx)
                  this.$wx.config({
                    // debug: true,
                    appId: res.appId,
                    timestamp: res.timestamp,
                    nonceStr: res.nonceStr,
                    signature: res.signature,
                    jsApiList: [
                      'scanQRCode',
                      'getLocation',
                      'chooseImage',
                      'getLocalImgData',
                      'updateAppMessageShareData',
                      'updateTimelineShareData']
                  })
                  this.$wx.ready(() => {
                    this.$wx.updateAppMessageShareData(this.share())
                    this.$wx.updateTimelineShareData(this.share())
                  })
                  this.$wx.error(err => {
                    console.error('wx config error:', err)
                  })
                })
                .catch(err => {
                  console.error('wx config error:', err)
                })
            } else if (window.isLark || this.$store.getters.env === ENV_TYPE_LARK_MINI_PROGRAM) {
              this.$store.dispatch('actionLarkTicket', location.href.split('#')[0])
                .then(res => {
                  return new Promise((resolve, reject) => {
                    console.log('$tt-config', this.$tt)
                    this.$tt.config({
                      appId: res.appId,
                      timestamp: res.timestamp,
                      nonceStr: res.nonceStr,
                      signature: res.signature,
                      jsApiList: ['device.geolocation.get', 'biz.util.scan', 'biz.util.previewImage'],
                      onSuccess: (res) => console.log(`config: success ${JSON.stringify(res)}`)
                    })
                  })
                  this.$tt.error(err => {
                    console.error('config error', JSON.stringify(err));
                  })
                })
                .catch(err => {
                  console.error('wx config error:', err)
                })
            } else if (window.isDingtalk) {
              this.$store.dispatch('actionDingtalkTicket', location.href.split('#')[0])
                .then(res => {
                  return new Promise((resolve, reject) => {
                    this.$dd.config({
                      agentId: res.agentId,
                      corpId: res.corpId,
                      timeStamp: res.timeStamp,
                      nonceStr: res.nonceStr,
                      signature: res.signature,
                      jsApiList: ['device.geolocation.get', 'biz.util.scan', 'biz.util.previewImage', 'biz.util.chooseImage'],
                    })
                    this.$dd.error(err => {
                      console.error('dd config error', JSON.stringify(err));
                      this.$toast.fail('3rd-dd-config onFail')
                    });
                  })
                })
                .catch(err => {
                  console.error('3rd-tt config error:', err)
                })
            }
          })
          .then(() => {

            const currentUserField = []
            Object.values(this.formSet.fields).forEach(field => {
              if (field.type === FORM_ITEM__CURRENT_VIEW_USER) {
                currentUserField.push(field)
              }
            })
            if (currentUserField.length && this.$store.getters.userId) {
              return this.$store.dispatch('actionMemberInfo', {
                companyId: this.formSet.companyId,
                userIdList: [this.$store.getters.userId]
              }).then(res => {
                if (res && Object.keys(res).length) {
                  currentUserField.forEach(field => {
                    const info = res[this.$store.getters.userId]
                    field.value.depart.push(...info.deptIdList)
                    field.value.role.push(...info.roleIdList)
                    field.value.externalTag.push(...info.tagList)
                  })
                }
                this.formSet.computeDisplayResults()
              })
            }
          })
          .then(() => {
            const btnListOpts = {
              appId: this.formSet.appId,
              formId: this.formSet.formId,
            }
            return Promise.all([
              this.$Socket.init(),
              this.$store.dispatch('actionTopicGet', {
                companyId: this.formSet.companyId,
                appId: this.formSet.appId,
                formId: this.formId
              }),
              this.$store.dispatch('actionApplyButtonList', btnListOpts)
            ])
          })
          .then(([init, res, btnList]) => {
            this.formSet.tmpTopic = res.tmpTopic
            this.$Socket.subscribe(res.tmpTopic, ({messageType, context, content}) => {
              console.log('$Socket--', messageType, content)
              if (messageType === this.$RySocket.MESSAGE_TYPE_PLUGIN_RESULT) {
                const {resultType, showMsg} = content
                if (showMsg && resultType === 'SUCCESS') {
                  this.$toast.success(showMsg)
                } else if (showMsg && resultType === 'FAIL') {
                  this.$toast.fail(showMsg)
                }
                const changeFlowEvent = new CustomEvent('PLUGIN_RESULT_RECEIVED', {detail: {context, content}})
                document.dispatchEvent(changeFlowEvent)
                return
              }

              handleMessage(this.formSet, {messageType, context, content})
            })

            btnList.forEach(btn => {
              if (btn.originName === 'submit' && btn.open) {
                this.applyBtnInfo.color = btn.textColor
                this.applyBtnInfo.name = btn.customName
                this.applyBtnInfo.backgroundColor = btn.customColor
              }
            })
          })
          .then(() => {
            this.formSet.isInit = true
          })
          .finally(() => this.pageLoading = false)
          .catch(console.error)
      },

      // 继续填写
      continueFill() {
        this.formSet = RyFormSet.init()
        this.structure()
        this.submitComplete = false
      },

      // 提交表单
      async formSubmit() {

        const opts = {
          depList: this.$store.getters.depListMap,
          roleList: this.$store.getters.roleListMap,
          userList: this.$store.getters.userListMap
        }
        if (this.formSet.checkMissingValue(opts)) {
          this.$toast.fail('存在不符合规范的值')
          return
        }
        const check = await this.checkComputeData()
        const uploading = await this.checkUploadFile()
        if (!check || !uploading) {
          return
        }

        if (this.currentFlowDetail && this.currentFlowDetail.openPay) {
          if (this.$refs.formOrderPopup) {
            this.$refs.formOrderPopup.open({
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              data: this.formSet.getValues(),
              stepId: ''
            })
          }
        } else {
          this.buttonClick()
        }

      },

      submitOrder({command, errList}) {
        this.orderErrorMsgList = errList
        this.buttonClick(command)
      },

      async buttonClick() {

        const opts = {
          depList: this.$store.getters.depListMap,
          roleList: this.$store.getters.roleListMap,
          userList: this.$store.getters.userListMap
        }
        if (this.formSet.checkMissingValue(opts)) {
          this.$toast.fail('存在不符合规范的值')
          return
        }
        const check = await this.checkComputeData()
        const uploading = await this.checkUploadFile()
        if (!check || !uploading) {
          return
        }
        const toast = this.$toast.loading({message: '加载中...'})
        const relateHandleMap = {}
        Object.keys(this.formSet.fields).forEach(key => {
          const field = this.formSet.fields[key]
          if (field.type === FORM_ITEM__RELATE_RECORD) {
            relateHandleMap[key] = {
              addInstanceList: field.addInstanceList, //新增的实例
              deleteInstanceList: field.deleteInstanceList //删除的实例
            }
          }
        })
        // 清空字段错误信息
        this.formSet.clearError()
        this.$store.dispatch('formApplyWithParam', {
          companyId: this.formSet.companyId,
          appId: this.formSet.appId,
          formId: this.formId,
          extField: this.extField,
          data: this.formSet.getValues(),
          relateHandleMap,
          showFieldIdList: this.formSet.fetchShowFieldIdList()
        }).then(({status, resultObject, info}) => {
          if (status === SUCCESS) {
            this.isSubmit = true
            this.createOrder({originName: 'submit', instanceId: resultObject.instanceId})
            this.submitCallback(resultObject)
          } else if (status === FORM_SUBMIT_ERROR && info) {
            // 表单字段校验未通过
            const errInfo = JSON.parse(base64Decode(info))
            console.log('errInfo', errInfo)
            if (errInfo) {
              this.formSet.setError(errInfo)
              this.$dialog.alert({
                title: '提交验证失败',
                message: errInfo.errorMessage,
              }).then(() => {
                // on close
              });
            }
          } else {
            this.$toast.fail({
              message: info,
              duration: '2000'
            })
          }
        }).catch(err => {
          console.error(err)
        }).finally(() => {
          toast.clear()
        })
      },
      // 检测关联数据服务器是否下发完
      checkComputeData() {
        if (this.formSet.submitMap && Object.keys(this.formSet.submitMap).length) {

          let errorType = ''
          if (Object.keys(this.formSet.submitMap).includes(this.formSet.lastSubmitTime)) {
            // 最后一条数据没回来， 数据异常
            errorType = 'EXCEPTION'
          } else {
            // 之前数据没回来， 丢数据
            errorType = 'LOSE_DATA'
          }
          this.$store.dispatch('actionFormMsgErrorUpload', {
            companyId: this.formSet.companyId,
            appId: this.formSet.appId,
            formId: this.formSet.formId,
            traceId: this.formSet.traceId,
            errorType,
            deviceType: 'MINI_APP',
            scene: 'CREATE',
            costTime: ''
          }).catch(console.error)
        }
        if (this.formSet.lastSubmitTime !== this.formSet.lastReciveTime && new Date().getTime() - this.formSet.lastSubmitTime < 10000) {
          return this.$dialog.confirm({
            title: '提示',
            message: '等待计算完成后提交数据，否则会丢失数据。如果弹框反复提示请联系客服！',
            confirmButtonText: '强制提交',
            cancelButtonText: '再等等'
          }).then(() => {
            return true
          }).catch(action => {
            return false
          })
        } else {
          return true
        }
      },

      checkUploadFile() {
        if (this.formSet.uploadFileMap && Object.keys(this.formSet.uploadFileMap).length) {
          const uploading = Object.values(this.formSet.uploadFileMap).some(item => item)
          if (uploading) {
            return this.$dialog.confirm({
              title:'提示',
              message: '当前有文件正在上传，是否等待？',
              confirmButtonText: '强制提交',
              cancelButtonText: '再等等'
            }).then(() => {
              return true
            }).catch(action => {
              return false
            })
          } else {
            return true
          }
        } else {
          return true
        }
      },
      fetchFlowDetail() {
        this.$store.dispatch('actionCompanyPaymentApplyFlowDetail', {
          appId: this.formSet.appId,
          formId: this.formSet.formId,
          stepId: ''
        }).then(res => {
          this.currentFlowDetail = res
        }).catch(console.error)
      },

      // 下单、跳转到收银台
      createOrder({originName, instanceId}) {
        if (this.currentFlowDetail &&
          this.currentFlowDetail.openPay &&
          (!this.orderErrorMsgList || !this.orderErrorMsgList.length) &&
          (originName === 'submit' || originName === 'agree')) {

          this.$store.dispatch('actionCompanyPaymentApplyOrderCreate', {
            companyId: this.formSet.companyId,
            appId: this.formSet.appId,
            formId: this.formSet.formId,
            instanceId,
            stepId: '',
          }).then(res => {
            this.$router.push({
              name: 'payment_gateway',
              query: {
                o: res.orderId
              }
            })
          }).catch(console.error)
        }
        this.orderErrorMsgList = null
      },

      // submit callback
      submitCallback(res) {
        console.log(res)
        this.instanceId = res.instanceId
        if (this.tempList && this.tempList.length) {
          if (this.$refs.printTemplateDialog) {
            this.$refs.printTemplateDialog.open()
          }
          return
        }
        this.submitComplete = true
        switch (res.afterJumpType) {
          case AFTER_JUMP_TYPE__DEFAULT:
            break
          case AFTER_JUMP_TYPE__CUSTOM:
          case AFTER_JUMP_TYPE__HTML:
            this.customInfo = res.customInfo
            break
          case AFTER_JUMP_TYPE__URL:
            if (this.aEle) {
              this.aEle.href = res.jumpUrl
              this.aEle.target = '_self'
              this.aEle.click()
            } else {
              this.jumpFail = true
            }
            break
          case AFTER_JUMP_TYPE__THIRD_PAGE:
            if (res.mobileJumpUrl) {
              if (!this.aEle) {
                this.aEle = document.createElement('a')
              }
              this.aEle.href = res.mobileJumpUrl
              if (res.openType === 'CURRENT') {
                this.aEle.target = '_self'
              } else {
                this.aEle.target = '_blank'
              }
              this.aEle.click()
            } else {
              this.jumpFail = true
            }
            break
          default:
            break
        }
      },

      handleScroll() {

        const tab = document.getElementsByClassName('el-tabs__header')[0]
        const content = document.getElementsByClassName('form-set-posting')[0]

        if (!document.querySelector('#formTabs')) {
          return
        }
        const offsetTop = document.querySelector('#formTabs').offsetTop


        if (content.scrollTop > offsetTop) {
          tab.style.position = 'fixed'
          tab.style.top = 0
          tab.style.left = 0
          tab.style.right = 0
          tab.style.zIndex = 1000
          tab.style.background = '#ffffff'
        } else {
          tab.style.position = 'relative'
          tab.style.top = 0
          tab.style.zIndex = 0
          tab.style.background = '#ffffff'
        }
        console.log('handleScroll', content.scrollTop, offsetTop)
      },

      beforeunloadHandler() {
        if (!this.isSubmit) {
          localStorage.setItem('apply_data', JSON.stringify(this.formSet.getValues()))
        }
      },

      share() {
        return {
          title: this.formSet.formName, // 分享标题
          desc:  this.formSet.customContent || this.formSet.formName, // 分享描述
          link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.formSet.customShowImg || this.$store.getters.configMap.singleLogoImage, // 分享图标
          success: function () {
            // 设置成功
            console.log('ShareData setting suc')
          }
        }
      },

      submitCustomCancel() {

      }
    }
  }
</script>

<style lang="less">

  .error-page {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 300px;
      margin-top: 80px;
    }

    p {
      margin-top: 30px;
      color: #333333;
    }
  }

  .posting-container {
    height: calc(100% - env(safe-area-inset-bottom));
    background-color: #fff;

    .link-posting__password {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .link-posting__password-container {
        margin: 0 20px;
        width: 100%;

        .header {
          width: 100%;
          height: 44px;
          background-color: #3a8ee6;
          color: #fff;
          text-align: center;
          padding: 12px;
        }

        .password-container {
          background-color: #fff;
          padding: 20px;
        }

        .van-field {
          border: 1px solid #DCDFE6;
          border-radius: 5px;
          height: 36px;
          padding: 5px 10px;
          margin-bottom: 10px;

          .van-field__control {
            font-size: 12px;
          }
        }
      }
    }

    .form-set-posting {
      box-sizing: border-box;
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      /*> .form-set__body {*/
      /*  flex: 1;*/
      /*  -webkit-overflow-scrolling: touch;*/
      /*  !*height: calc(100% - 51px - env(safe-area-inset-bottom));*!*/
      /*  overflow-y: scroll;*/
      /*}*/

      .form-content {

        > header {
          background-color: rgba(0, 0, 0, 0.2);
          position: relative;

          > .form-set__title {
            box-sizing: border-box;
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
            position: absolute;
            top: 50%;
            text-align: center;
            width: 100%;
            transform: translateY(-50%);
            line-height: 40px;
            padding: 0 36px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          > .form-set__des {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            font-size: 12px;
            color: #ffffff;
            background-color: rgba(0, 0, 0, 0.4);
            padding: 0 16px;
            line-height: 30px;
            height: 30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      /*> .form__section {*/
      /*  flex: 1;*/
      /*}*/


      .footer {
        height: 90px;
        width: 100%;
        background-color: #FFFFFF;
        position: relative;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        /*bottom: calc(env(safe-area-inset-bottom));*/
        /*z-index: 100;*/

        .van-button {
          height: 44px;
          width: 80%;
          margin-top: 10px;
          border-radius: 8px;

          .van-button__text {
            font-weight: 500;
            font-size: 14px;
          }
        }

        .disclaimer {
          width: 100%;
          font-size: 12px;
          margin: 10px 0;
          padding: 0 20px;
          position: relative;
          height: 20px;

          > div {
            font-size: 12px;
            color: #989898;
            text-align: center;
          }

          a {
            position: absolute;
            top: 0;
            right: 5px;
            font-size: 12px;
            color: #73a5da;
            cursor: pointer;
            outline: 0;
            text-decoration: none;
            width: 70px;
          }
        }
      }
    }

    .submit-complete-container {
      height: 100%;
      width: 100%;
      background-color: #fff;

      .submit-default-container,
      .submit-custom-container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 40px;

        .submit-custom-btn-container {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 20px;

          .van-button {
            width: 100px;
          }
        }

        .van-image {
          margin-top: 100px;
        }

        .tips {
          margin-top: 20px;
        }

        .van-button {
          margin-top: 20px;
        }

        .custom-info-container {
          width: 100%;
          height: 100%;
          margin: 50px 0;
          overflow: auto;
          -webkit-overflow-scrolling: touch;

          box-sizing: border-box;
          line-height: 1.42;
          height: 100%;
          outline: none;
          overflow-y: auto;
          padding: 12px 15px;
          -o-tab-size: 4;
          tab-size: 4;
          -moz-tab-size: 4;
          text-align: left;
          white-space: pre-wrap;
          word-wrap: break-word;
        }
      }

      .ql-editor {
        padding: 12px 20px;
        border: none;

        img {
          max-width: 100%;
        }
      }

      .ql-snow {
        border: none !important;
      }
    }
  }
</style>
